module.exports = __webpack_public_path__ + "static/img/loading-img.6b8258d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PageCommon/img/loading-img.gif
// module id = UpZK
// module chunks = 106